<div class="content">
    <div class="w-full flex mb-2" *ngIf="allowLegend">
        <div *ngFor="let item of data; let i = index" class="flex align-items-center mr-4 legend">
            <div class="border-circle border-2 label" [style.border-color]="item.gradientColors[0]"></div>

            <div [style.color]="item.gradientColors[0]" class="ml-2 title">
                {{ item.legend }}
            </div>
        </div>
    </div>
    <p-chart (mouseout)="display = 'none'" type="line" [height]="'20rem'" [data]="basicData" [options]="basicOptions"
        #chart
        [ngClass]="cursorPointer? 'cursor-pointer' : '' "
        ></p-chart >

    <div id="tooltip" [style.display]="display" [style.left]="leftpos" [style.top]="rightpos">
        <p [style.color]="currentColor" >
            {{ activedText.title | date:"dd.MM.yyyy"}} 
        </p>
        <span>
            {{ activedText.subtitle | currency : "BRL" }}
        </span>
    </div>
</div>